import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { TotalPerCurrencyFilter } from './total-per-currency-filter.model';

export const TOTAL_PER_MONTH_FILTER_SCHEMA = Object.freeze({
  MONTH: 0,
  YEAR: 0, // tax year
  TOTALS: List<TotalPerCurrencyFilter>([]),
});
const RECORD = generateSchema(TOTAL_PER_MONTH_FILTER_SCHEMA);
const KEYS: any = generateKeys(TOTAL_PER_MONTH_FILTER_SCHEMA);

export class TotalPerMonthFilter extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.TOTALS,
        value: props.get(KEYS.TOTALS)
          ? this.totals.map((params) => new TotalPerCurrencyFilter(params))
          : List<TotalPerCurrencyFilter>([]),
      },
    ]);

    return selfModel as TotalPerMonthFilter;
  }

  get month(): number {
    return this.get(KEYS.MONTH);
  }

  get totals(): List<TotalPerCurrencyFilter> {
    return this.get(KEYS.TOTALS);
  }

  get year(): number {
    return this.get(KEYS.YEAR);
  }
}
